import DurationFilter from "../DurationFilter";
import BagsFilter from "../BagsFilter";
import TimesFilter from "../TimesFilter";
import { markup } from "../../../../helpers/Prices";

import {
    add_commas_to_number,
} from "../../../../helpers/general";

const Type1FlightTopFilters = (props) => {

    const {
        bookingEngine,
        canShowPrice,
        PriceMarkupValue,
        CURRENCY_SYMBOL,
        flightsMinPrice,
        flightsSliderMaxPrice,
        flightsMaxPrice,
        slidePriceFilter,
        SLIDER_MIN_PERCENT,
        priceSlider,
        isShowTimesFilter,
        filterTimes,
        filtersByTimes,
        filterFlights,
        hideTimesFilter,
        hasNewMessageFromParent,
        currentParentMessge,
        showTimesFilter,
        isShowBagsFilter,
        checkedBagsFilterQuantity,
        carryOnBagsFilterQuantity,
        setCheckedBagsFilterQuantity,
        setCarryOnBagsFilterQuantity,
        hideBagsFilter,
        maxCheckedBagsFilter,
        maxCarryOnBagsFilter,
        filterBags,
        showBagsFilter,
        isShowDurationFilter,
        flightsMinDuration,
        flightsMaxDuration,
        D_SLIDER_MIN_PERCENT,
        slideDurationFilter,
        durationSlider,
        flightsSliderMaxDuration,
        hideDurationFilter,
        showDurationFilter,
    } = props;

    return <div style={{padding: 10, marginTop: 10}}>
        <div style={{display: "flex", justifyContent: "space-between"}}>
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <p style={{color: "rgba(0,0,0,0.8)", fontSize: 10, fontFamily: "'Prompt', Sans-serif"}}>
                        {
                            (canShowPrice?.show && (!canShowPrice?.with_price_bound_profit || PriceMarkupValue?.value)) ?
                            <span style={{fontSize: 18, fontFamily: "'Prompt', Sans-serif", color: "rgba(0,0,0,0.7)", fontWeight: "bolder"}} 
                            dangerouslySetInnerHTML={{__html: CURRENCY_SYMBOL}}></span> : ""
                        }
                        { 
                            canShowPrice?.show ?
                                <> 
                                    {
                                        !canShowPrice?.with_price_bound_profit ?
                                        add_commas_to_number(parseFloat(flightsMinPrice)?.toFixed(0)) :
                                        <>
                                            {
                                                PriceMarkupValue?.value ?
                                                (add_commas_to_number((markup(flightsMinPrice, PriceMarkupValue?.value, PriceMarkupValue?.type)?.new_price)?.toFixed(0)))
                                                : "N/A"
                                            }
                                        </>
                                    }
                                </>
                            : <span style={{color: "rgba(0,0,0,0.8)"}}>
                                <i className="fa-solid fa-filter-circle-dollar"></i>
                            </span>
                        }
                    </p>
                    <p style={{color: "crimson", fontSize: 10, fontWeight: "bolder", fontFamily: "'Prompt', Sans-serif"}}>
                        {
                            (canShowPrice?.show && (!canShowPrice?.with_price_bound_profit || PriceMarkupValue?.value)) ?
                            <span style={{fontSize: 18, fontFamily: "'Prompt', Sans-serif", color: "rgba(0,0,0,0.7)", fontWeight: "bolder"}} 
                            dangerouslySetInnerHTML={{__html: CURRENCY_SYMBOL}}></span> : ""
                        }
                        { 
                            canShowPrice?.show ?
                                <> 
                                    {
                                        !canShowPrice?.with_price_bound_profit ?
                                        add_commas_to_number(parseFloat(flightsSliderMaxPrice)?.toFixed(0)) :
                                        <>
                                            {
                                                PriceMarkupValue?.value ?
                                                (add_commas_to_number((markup(flightsSliderMaxPrice, PriceMarkupValue?.value, PriceMarkupValue?.type)?.new_price)?.toFixed(0)))
                                                : "N/A"
                                            }
                                        </>
                                    }
                                </>
                            : <span style={{color: "rgba(0,0,0,0.8)"}}>
                                <i className="fa-solid fa-filter-circle-dollar"></i>
                            </span>
                        }
                    </p>
                    <p style={{color: "rgba(0,0,0,0.8)", fontSize: 10, fontFamily: "'Prompt', Sans-serif"}}>
                        {
                            (canShowPrice?.show && (!canShowPrice?.with_price_bound_profit || PriceMarkupValue?.value)) ?
                            <span style={{fontSize: 18, fontFamily: "'Prompt', Sans-serif", color: "rgba(0,0,0,0.7)", fontWeight: "bolder"}} 
                            dangerouslySetInnerHTML={{__html: CURRENCY_SYMBOL}}></span> : ""
                        }
                        { 
                            canShowPrice?.show ?
                                <> 
                                    {
                                        !canShowPrice?.with_price_bound_profit ?
                                        add_commas_to_number(parseFloat(flightsMaxPrice)?.toFixed(0)) :
                                        <>
                                            {
                                                PriceMarkupValue?.value ?
                                                (add_commas_to_number((markup(flightsMaxPrice, PriceMarkupValue?.value, PriceMarkupValue?.type)?.new_price)?.toFixed(0)))
                                                : "N/A"
                                            }
                                        </>
                                    }
                                </>
                            : <span style={{color: "rgba(0,0,0,0.8)"}}>
                                <i className="fa-solid fa-filter-circle-dollar"></i>
                            </span>
                        }
                    </p>
                </div>
                <input 
                    onInput={slidePriceFilter}
                    className="styled-slider slider-progress" 
                    min={SLIDER_MIN_PERCENT} max="101" 
                    value={priceSlider} type="range" />
            </div>
            <div style={{marginLeft: 20, display: "flex"}}>
                <div style={{position: "relative"}}>
                    {
                        isShowTimesFilter &&
                        <TimesFilter 
                            filterTimes={filterTimes}
                            filtersByTimes={filtersByTimes}
                            filterFlights={filterFlights}
                            hideTimesFilter={hideTimesFilter}
                            hasNewMessageFromParent={hasNewMessageFromParent}
                            currentParentMessge={currentParentMessge}
                        />
                    }
                    <div onClick={showTimesFilter}
                        className="hover_bg-grey show_only_mobile_flex" 
                            style={{display: "none", cursor: "pointer", borderRadius: "100%", height: 40, width: 40, justifyContent: "center", alignItems: "center"}}>
                        <i style={{color: bookingEngine?.searchFiltersIconColor, fontSize: 17}} 
                            className="fa-solid fa-clock"></i>    
                    </div>
                    <div onClick={showTimesFilter}
                        className="mobile_hidden hover_bg-grey" style={{cursor: "pointer", padding: "7px 13px", borderRadius: 8, display: "flex", alignItems: "center"}}>
                        <i style={{marginRight: 10, color: bookingEngine?.searchFiltersIconColor, fontSize: 13.5}} 
                            className="fa-solid fa-clock"></i>
                        <p style={{color: bookingEngine?.searchFiltersTxtColor, fontSize: 13, fontWeight: "bolder", fontFamily: "'Prompt', Sans-serif"}}>
                            Time
                        </p>
                        <i style={{marginLeft: 15, color: bookingEngine?.searchFiltersIndicatorColor, fontSize: 13}} 
                            className="fa-solid fa-angle-down"></i>
                    </div>
                </div>
                <div style={{position: "relative"}}>
                    {
                        isShowBagsFilter && 
                        <BagsFilter 
                            checkedBagsFilterQuantity={checkedBagsFilterQuantity}
                            carryOnBagsFilterQuantity={carryOnBagsFilterQuantity}
                            setCheckedBagsFilterQuantity={setCheckedBagsFilterQuantity}
                            setCarryOnBagsFilterQuantity={setCarryOnBagsFilterQuantity}
                            hideBagsFilter={hideBagsFilter} 
                            maxCheckedBagsFilter={maxCheckedBagsFilter}
                            maxCarryOnBagsFilter={maxCarryOnBagsFilter}
                            filterBags={filterBags}
                            hasNewMessageFromParent={hasNewMessageFromParent}
                            currentParentMessge={currentParentMessge}
                        />
                    }
                    <div onClick={showBagsFilter}
                        className="hover_bg-grey show_only_mobile_flex" style={{display: "none", cursor: "pointer", borderRadius: "100%", height: 40, width: 40, justifyContent: "center", alignItems: "center"}}>
                        <i style={{color: bookingEngine?.searchFiltersIconColor, fontSize: 19}} 
                            className="fa-solid fa-cart-flatbed-suitcase"></i>    
                    </div>
                    <div onClick={showBagsFilter}
                        className="mobile_hidden hover_bg-grey" style={{cursor: "pointer", padding: "7px 13px", borderRadius: 8, display: "flex", alignItems: "center"}}>
                        <i style={{marginRight: 10, color: bookingEngine?.searchFiltersIconColor, fontSize: 15}} 
                            className="fa-solid fa-cart-flatbed-suitcase"></i>
                        <p style={{color: bookingEngine?.searchFiltersTxtColor, fontSize: 13, fontWeight: "bolder", fontFamily: "'Prompt', Sans-serif"}}>
                            Bags
                        </p>
                        <i style={{marginLeft: 15, color: bookingEngine?.searchFiltersIndicatorColor, fontSize: 13}} 
                            className="fa-solid fa-angle-down"></i>
                    </div>
                </div>
                <div style={{position: "relative"}}>
                    {
                        isShowDurationFilter && 
                        <DurationFilter 
                            flightsMinDuration={flightsMinDuration}
                            flightsMaxDuration={flightsMaxDuration}
                            SLIDER_MIN_PERCENT={D_SLIDER_MIN_PERCENT}
                            slideDurationFilter={slideDurationFilter}
                            durationSlider={durationSlider}
                            flightsSliderMaxDuration={flightsSliderMaxDuration}
                            hideDurationFilter={hideDurationFilter} 
                            hasNewMessageFromParent={hasNewMessageFromParent}
                            currentParentMessge={currentParentMessge}
                        />
                    }
                    <div onClick={showDurationFilter}
                        className="hover_bg-grey show_only_mobile_flex" style={{display: "none", cursor: "pointer", borderRadius: "100%", height: 40, width: 40, justifyContent: "center", alignItems: "center"}}>
                        <i style={{color: bookingEngine?.searchFiltersIconColor, fontSize: 17}} 
                            className="fa-solid fa-hourglass-half"></i>    
                    </div>
                    <div onClick={showDurationFilter}
                        className="mobile_hidden hover_bg-grey" style={{marginLeft: 5, cursor: "pointer", padding: "7px 13px", borderRadius: 8, display: "flex", alignItems: "center"}}>
                        <i style={{marginRight: 10, color: bookingEngine?.searchFiltersIconColor, fontSize: 13}} 
                            className="fa-solid fa-hourglass-half"></i>
                        <p style={{color: bookingEngine?.searchFiltersTxtColor, fontSize: 13, fontWeight: "bolder", fontFamily: "'Prompt', Sans-serif"}}>
                            Duration
                        </p>
                        <i style={{marginLeft: 15, color: bookingEngine?.searchFiltersIndicatorColor, fontSize: 13}} 
                            className="fa-solid fa-angle-down"></i>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

}

export default Type1FlightTopFilters;